import { render, staticRenderFns } from "./apiClientManagement.vue?vue&type=template&id=55742438&scoped=true"
import script from "./apiClientManagement.vue?vue&type=script&lang=js"
export * from "./apiClientManagement.vue?vue&type=script&lang=js"
import style0 from "./apiClientManagement.vue?vue&type=style&index=0&id=55742438&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55742438",
  null
  
)

export default component.exports